import { Component, Element, Prop, h } from '@stencil/core';
import { BlogPost } from '../../../types/blog';
import { Consumer } from '@sydle/ui-utils';

@Component({
  tag: 'sy-blog-related-posts',
  styleUrl: 'scss/index.scss',
  scoped: true,
})
export class SyBlogRelatedPosts {
  private consumer: Consumer;
  @Element() el: HTMLSyBlogRelatedPostsElement;

  /**
   * Post body
   */
  @Prop() postBody: BlogPost;

  /**
   * Sets the title of the related posts section.
   */
  @Prop() relatedPostsTitle: string;

  connectedCallback() {
    this.consumer = new Consumer(this.el);
    this.consumer.subscribe('postBody', (post: BlogPost) => (this.postBody = post));
  }

  disconnectedCallback() {
    this.consumer.disconnect();
  }

  render() {
    return this?.postBody?.relatedPosts && this.postBody.relatedPosts.length > 0 ? (
      <section class="related-posts">
        <sy-grid type="flex">
          <sy-row>
            <sy-col size="12">
              <sy-text type="h4" class="sy-mt-4 sy-mb-7">
                {this.relatedPostsTitle}
              </sy-text>
            </sy-col>
          </sy-row>
          <sy-row>
            {this.postBody.relatedPosts.map((post) => (
              <sy-col key={post.identifier} size="12" size-lg="6" class="sy-mb-5">
                <sy-blog-related-post-card post={post} />
              </sy-col>
            ))}
          </sy-row>
        </sy-grid>
      </section>
    ) : null;
  }
}
